// Продление сцены Gemini Omni (Original): «к какому ролику дописываем хвост».
//
// Google продлевает не файл, а СВОЮ предыдущую интеракцию, поэтому продлить
// можно только собственную завершённую генерацию той же карточки. Пункт
// «Продлить сцену» в студии кладёт сюда её requestId, а ApiClient подмешивает
// его в тело следующей генерации полем extend_source_request_id — ровно так
// же, как editSourceTracker подмешивает тег цепочки правок.
//
// Тег ЛИПКИЙ, но привязан к модели: пока выбрана та же карточка, продление
// переживает ретрай после «не хватило токенов» и «Пересоздать» (one-shot терял
// бы его на неудачной попытке). Смена модели снимает контекст — у других
// моделей продления нет, и молча слать им чужой id незачем.
//
// Снять вручную можно крестиком на пине (SceneExtendPin).

export interface SceneExtendSource {
	/** requestId генерации, чью сцену продлеваем. */
	requestId: string
	/** backendModel карточки, на которой сцена сделана (у Omni Original он же
	 *  и id): смена модели снимает контекст. Сверяется с `model` в теле
	 *  запроса — там едет именно backendModel. */
	modelId: string
	/** Уже накопленная длина сцены, сек — пин показывает «Nс → Mс». */
	sceneSeconds: number
	/** Промпт исходной генерации — для подписи пина. */
	prompt?: string
}

let source: SceneExtendSource | null = null
const listeners = new Set<() => void>()

function emit(): void {
	listeners.forEach((fn) => fn())
}

export function setSceneExtendSource(next: SceneExtendSource | null): void {
	source = next
	emit()
}

export function getSceneExtendSource(): SceneExtendSource | null {
	return source
}

export function clearSceneExtendSource(): void {
	setSceneExtendSource(null)
}

/** Тег для уходящего запроса — только если генерация идёт на ТОЙ ЖЕ модели.
 *  Чужая модель не «ошибка юзера», а обычная смена карточки: тихо снимаем. */
export function consumeSceneExtendForModel(model: string | null): string | null {
	if (!source) return null
	if (model !== source.modelId) {
		clearSceneExtendSource()
		return null
	}
	return source.requestId
}

export function subscribeSceneExtend(fn: () => void): () => void {
	listeners.add(fn)
	return () => {
		listeners.delete(fn)
	}
}
